
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { TicketService } from "@/services/ticket-service";
import { AuthService } from "@/services/auth-service";

export default Vue.extend({
	data() {
		return {
			selectedDay: 1,
			selectedMoment: 0,
			available: [] as string[],
			hours: [] as string[][],
			availableHours: ["08:00u", "09:00u", "10:00u", "11:00u", "13:00u", "14:00u", "15:00u", "16:00u", "17:00u"],
		};
	},
	computed: {
		calendlyLink(): string {
			let d = new Date();
			return "https://calendly.com/winfakt/plan-je-moment?month="
				+d.getFullYear()+"-"+("0" + (d.getMonth() + 1)).slice(-2)+"&email="
				+AuthService.wfUser.Email+"&name="+AuthService.wfUser.getUserFullName();
		},
		days(): ISelectItem<number>[] {
			let items = [] as ISelectItem<number>[];
			for (let i = 0; i < this.$ct("days").length; i++) {
				items.push({
					text: this.$ct("days." + (i)).toString(),
					value: i + 1
				});
			}
			return items;
		},
		when() {
			let items = [] as ISelectItem<number>[];
			for (let i = 0; i < Object.keys(this.available).length; i++) {
				items.push({
					text: this.available[i],
					value: i
				});
			}
			return items;
		},
	},
	watch: {
		selectedMoment() {
			if (this.when[this.selectedMoment]["text"].toString().includes(this.$ct("occupied").toString())) {
				this.$nextTick(() => {
					this.selectedMoment = 0;
				});
			}
		},
		selectedDay() {
			this.available = this.hours[this.selectedDay];
		}
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		async shedule() {
			let subject = this.$ct("ticket-subject").toString();
			let content = this.$ct("ticket-content", {
				firstname: AuthService.wfUser.Firstname,
				day: this.$ct("days." + (this.selectedDay - 1)),
				time: this.when[this.selectedMoment]["text"].toString()
			}).toString();
			let ticket = await TicketService.newTicket(subject, content, [], "2", "2");
			this.$router.push(`/support/tickets/${ticket.id}`);
		},
		toggleUnavailable(): string[] {
			let n1 = Math.floor(Math.random() * 8) + 1;
			let n2 = Math.floor(Math.random() * 4) + 1;
			let hours = Object.assign({}, this.availableHours);
			hours[n1] = hours[n1] + " " + this.$ct("occupied");
			if (n1 !== n2) {
				hours[n2] = hours[n2] + " " + this.$ct("occupied");
			}
			return hours;
		},
		createTimeArray() {
			for (let i = 0; i < 5; i++) {
				this.hours.push(this.toggleUnavailable());
			}
		}
	},
	created() {
		this.createTimeArray();
		this.available = this.hours[this.selectedDay];
	},
	i18nEx: {
		componentPrefix: "components.account.demo-shedule"
	}
});

